import { gql } from '@apollo/client';

const FranchiseeRegistered = gql`
  mutation($input: FranchiseeRegisteredInput!){
    FranchiseeRegistered(input: $input)
  }
`;

export default FranchiseeRegistered;
